module.exports = __webpack_public_path__ + "static/plaza-city-d04fd6ca885a5d10b20f89d71589a207.png";